import React from 'react';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './share-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var propLabels = {
  numPeopleWanted: 'Number of people sought:',
  numRoomsAvailable: 'Rooms available:',
  numCurrentOccupants: 'Current occupants:'
};
var ShareDetails = props => {
  var renderItems = Object.keys(propLabels).map(label => ___EmotionJSX("div", {
    css: styles.item,
    key: label
  }, ___EmotionJSX("span", {
    css: styles.itemLabel
  }, propLabels[label]), ___EmotionJSX("span", {
    css: styles.itemValue
  }, props[label])));
  return ___EmotionJSX("section", {
    css: styles.shareDetails
  }, ___EmotionJSX(Heading, {
    css: styles.heading,
    title: "Share details"
  }), ___EmotionJSX("div", {
    css: styles.body
  }, renderItems));
};
export default ShareDetails;